import { rotinasNaoConformidade } from "~/composables/menus/rotinas/naoConformidade/rotinas";

export default function () {
	return rotinasNaoConformidade;
}
